import { render, staticRenderFns } from "./BooksQRScanner.vue?vue&type=template&id=0b4e7f3a&scoped=true&"
import script from "./BooksQRScanner.vue?vue&type=script&lang=js&"
export * from "./BooksQRScanner.vue?vue&type=script&lang=js&"
import style0 from "./BooksQRScanner.vue?vue&type=style&index=0&id=0b4e7f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4e7f3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
